import { API_URL } from "../config";
import axios from "../utils/axios";
import { ValidateEventFilter } from "./Helpers";

class CameraEventRepository {
  getAll(filter) {
    if (!ValidateEventFilter(filter)) {
      return Promise.reject(
        "Date range should be max 1 day in case of other filters are not selected"
      );
    }

    return axios.get(API_URL + "/CameraEvent/List?", { params: filter });
  }

  getById(id) {
    return axios.get(API_URL + `/CameraEvent/${id}`);
  }

  getAdjacentEventsById(id) {
    return axios.get(API_URL + `/CameraEvent/AdjacentEvents/${id}`);
  }

  previewUpdateChanges(data) {
    return axios.post(API_URL + `/CameraEvent/PreviewUpdateEvent`, data);
  }

  updateEvent(data) {
    return axios.post(API_URL + `/CameraEvent/UpdateEvent`, data);
  }

  delete(id) {
    return axios.delete(API_URL + `/CameraEvent/${id}`);
  }

  export(filter) {
    return axios.get(API_URL + "/CameraEvent/Export?", {
      params: filter,
      responseType: "blob",
    });
  }
}

export default CameraEventRepository;
